import React from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, ArrowRight } from "@phosphor-icons/react";
import { CALENDLY_URL, CONSULT_PRICE } from "@/lib/constants";
import api from "@/lib/api";

function openConsult(source) {
  api.post("/events", { event: "paid_cta_clicked", meta: { source } }).catch(() => {});
  window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
}

// Full CTA block (dashboard home / reports / result page)
export function ConsultBlock({
  source = "generic",
  headline = "Ready to break these patterns with real support?",
  sub = "Work 1-on-1 with a coach who deeply understands your specific patterns and can help you create lasting change.",
}) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-amber-500/30 bg-gradient-to-br from-slate-900 to-slate-950 p-7 sm:p-9" data-testid="consult-block">
      <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-amber-500/10 blur-3xl" />
      <div className="relative">
        <span className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-amber-400">
          <CalendarCheck size={13} weight="fill" /> 1:1 Integration Support
        </span>
        <h3 className="mt-4 font-heading text-2xl font-medium text-slate-100">{headline}</h3>
        <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400">{sub}</p>
        <button
          onClick={() => openConsult(source)}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-amber-500 px-7 py-3.5 text-sm font-semibold text-slate-950 transition-all hover:bg-amber-400"
          data-testid="consult-cta-btn"
        >
          Book a 1:1 Integration Session — {CONSULT_PRICE} <ArrowRight size={16} weight="bold" />
        </button>
        <p className="mt-3 text-xs text-slate-500">Sessions are conducted via Zoom. 60 minutes.</p>
        <Link to="/about" className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-teal-400 hover:text-teal-300" data-testid="consult-meet-avnni">Meet Avnni — see who you'll be talking to <ArrowRight size={12} weight="bold" /></Link>
      </div>
    </div>
  );
}

// Inline button (cards)
export function ConsultButton({ source = "card", label = "Book Integration Session", className = "" }) {
  return (
    <button
      onClick={() => openConsult(source)}
      className={`inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 px-4 py-2 text-xs font-semibold text-amber-400 transition-all hover:bg-amber-500/10 ${className}`}
      data-testid="consult-button"
    >
      <CalendarCheck size={14} weight="fill" /> {label}
    </button>
  );
}
